import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import LoanList from './LoanList';

const Loan = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Listado de prestamos' pageTitle='Prestamos' />
                <LoanList />
            </div>
        </React.Fragment>
    )
}

export default Loan;